<template>
  <section>
    <b-overlay
      :show='loading'
      rounded
      no-center
      opacity='0.6'
      spinner-small
      spinner-variant='primary'
      class='d-inline-block w-100'
      style='min-height: 250px'
    >
      <section class="mb-3">
        <section class="filters">
          <section>
            <label>Data inicial</label>
            <b-form-input
              v-model="importedFileMeta.startDate"
              placeholder="Data inicial"
              type="date"
            >
            </b-form-input>
          </section>

          <section>
            <label>Data final</label>
            <b-form-input
              v-model="importedFileMeta.endDate"
              placeholder="Data final"
              type="date"
            >
            </b-form-input>
          </section>

          <section>
            <label>E-mail</label>
            <b-form-input
              v-model="importedFileMeta.filter"
              placeholder="E-mail"
              type="search"
            >
            </b-form-input>
          </section>
        </section>

        <section class="mt-3 d-flex justify-content-end">
          <section class="">
            <b-button @click="getImportedFiles(1)" variant="success">
              <b-icon
                icon='search'
                font-scale=".9"
                class="mr-1"
              >
              </b-icon>
              <span>Pesquisar</span>
            </b-button>

            <b-button @click="reset()" variant="info" class="ml-2">
              <b-icon
                icon='arrow-repeat'
                class="mr-1"
              >
              </b-icon>
              <span>Limpar filtros</span>
            </b-button>
          </section>
        </section>
      </section>

      <section>
        <base-table
          :columns='columns'
          :data='importedFiles'
          :total-items='importedFileMeta.total'
          :start-items='importedFileMeta.skip + 1'
          :max-items='importedFileMeta.limit'
          @set-page='getImportedFiles'
        >
          <template v-slot:body-user='row'>
            {{ row.item && row.item.user && row.item.user.username ? row.item.user.username : '' }}
          </template>
          <template v-slot:body-createdAt='row'>
            {{ row.item && row.item.createdAt && row.item.createdAt ? formatDate(row.item.createdAt) : '' }}
          </template>
          <template v-slot:body-filePath='row'>
            <a
              :href="row.item.filePath"
              target="_blank"
              v-if="row.item && row.item.filePath"
            >
              {{row.item.fileName}}
            </a>
            <span v-else>
              -
            </span>
          </template>
        </base-table>
      </section>

      <template v-slot:overlay>
        <div class='text-center loading-spinner'>
          <b-spinner style='width: 3rem; height: 3rem;' variant='primary' label='Large Spinner'></b-spinner>
          <h5 class='text-primary'>Buscando...</h5>
        </div>
      </template>
    </b-overlay>
  </section>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import format from 'date-fns/esm/format/index'

export default {
  name: 'ImportedFile',
  data() {
    return {
      loading: false,
      description: '',
      title: '',
      webAppUserBond: Object,
      columns: [
        { key: 'user', value: 'Usuário' },
        { key: 'createdAt', value: 'Data da importação' },
        { key: 'filePath', value: 'Arquivo importado' }
      ]
    }
  },
  components: {},
  computed: {
    ...mapGetters('importedFile', {
      importedFiles: 'importedFiles',
      importedFileMeta: 'importedFileMeta'
    })
  },
  watch: {},
  methods: {
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb'
    }),
    ...mapActions('importedFile', {
      handleGetAllPaginated: 'handleGetAllPaginated',
      handleResetMeta: 'handleResetMeta'
    }),
    async reset() {
      this.loading = true
      await this.handleResetMeta()
      await this.handleGetAllPaginated({})
      this.loading = false
    },

    async getImportedFiles(page) {
      try {
        this.loading = true
        const pageCount = page <= 0 ? 1 : page

        const params = {
          ...this.importedFileMeta,
          skip: ((pageCount - 1) * this.importedFileMeta.limit)
        }
        await this.handleGetAllPaginated(params)
        this.loading = false
      } catch (e) {

      }
    },
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy HH:mm:ss')
    }
  },
  async mounted() {
    this.loading = true
    await this.handleGetAllPaginated({})
    this.loading = false
  },
  async created() {
  }
}
</script>

<style lang='scss' scoped>
.filters {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  section {
    width: 33%;
    min-width: 300px;
  }
}

</style>
